import React, { useMemo, type HTMLAttributes, type PropsWithChildren } from 'react';
import { filterHTMLAttributesInFlexBoxProps } from './flex-box-utils';
import styles from './FlexBox.module.scss';

export interface FlexBoxProps extends HTMLAttributes<HTMLElement> {
  as?: React.ElementType;
  direction?: 'row' | 'column';
  content?: 'start' | 'end' | 'center' | 'space-between';
  aligns?: 'start' | 'end' | 'center';
  isFullWidth?: boolean;
  wrap?: boolean;
}

export const FlexBox: React.FC<PropsWithChildren<FlexBoxProps>> = (props) => {
  const {
    as,
    direction,
    content,
    aligns,
    children,
    className = '',
    isFullWidth,
    wrap,
  } = props;

  const mergedStyles: string = useMemo(() => {
    let joinClassName = styles.flex;
    if (direction === 'column') joinClassName += ` ${styles.columnDirection}`;
    if (direction === 'row') joinClassName += ` ${styles.rowDirection}`;
    if (aligns === 'start') joinClassName += ` ${styles.alignStart}`;
    if (aligns === 'end') joinClassName += ` ${styles.alignEnd}`;
    if (aligns === 'center') joinClassName += ` ${styles.alignCenter}`;
    if (content === 'center') joinClassName += ` ${styles.justifyCenter}`;
    if (content === 'start') joinClassName += ` ${styles.justifyStart}`;
    if (content === 'end') joinClassName += ` ${styles.justifyEnd}`;
    if (content === 'space-between') joinClassName += ` ${styles.justifySpaceBetween}`;
    if (isFullWidth) joinClassName += ` ${styles.fullWidth}`;
    if (wrap) joinClassName += ` ${styles.wrap}`;

    joinClassName += ` ${className}`;
    return joinClassName;
  }, [
    direction,
    content,
    aligns,
    className,
    isFullWidth,
    wrap
  ]);

  const htmlAttributesProps = filterHTMLAttributesInFlexBoxProps(props);

  return React.createElement(as ?? 'div', { ...htmlAttributesProps, className: mergedStyles }, children);
};
